// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import { bindingsDefinition, prop } from '@/hybrid/core/bindings.util';
import { useTranslation } from 'react-i18next';

const assetSelectionLabelBindings = bindingsDefinition({
  onClick: prop.optional<(e) => void>(),
  targetRef: prop.optional<any>(),
  assetName: prop<string>(),
});

export const AssetSelectionLabel: SeeqComponent<typeof assetSelectionLabelBindings> = ({
  onClick = null,
  targetRef = null,
  assetName,
}) => {
  const { t } = useTranslation();
  const loadingPlaceholder = t('REPORT.DATE_RANGE_LABEL.LOADING');
  const [content, setContent] = useState(loadingPlaceholder);

  useEffect(() => {
    if (assetName) {
      setContent(assetName);
    } else if (assetName === '') {
      setContent(t('REPORT.DATE_RANGE_LABEL.INVALID_ASSET_SELECTION'));
    }
  }, [assetName]);

  return (
    <span ref={targetRef} onClick={onClick} data-testid="assetSelectionLabelText">
      {content}
    </span>
  );
};
